<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">Número</th>
        <th scope="col" class="border-0 ">Cliente</th>
        <th scope="col" class="border-0 ">Atualizado em</th>
        <th scope="col" class="border-0 ">Tipo</th>
        <th scope="col" class="border-0 ">Criado</th>
        <th scope="col" class="border-0 ">Status</th>
        <th scope="col" class="border-0 ">Valor</th>
        <th scope="col" class="border-0 ">Temperatura (Q)</th>
        <th scope="col" class="border-0 ">Classificação</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in reports" :key="index" class="align-items-center">
        <td class="td-5 link">{{ row.reference_no }}</td>
        <td class="td-2">{{ row.name }}</td>
        <td class="td-2">{{ row.f_created_at }}</td>
        <td class="td-1">{{ row.type }}</td>
        <td class="td-1">{{ row.created_by }}</td>
        <td class="td-1">{{ row.status }}</td>
        <td class="td-1">{{ row.f_value }}</td>
        <td class="td-1">{{ row.temperature }}</td>
        <td class="td-1"><input-star :model='row.rating' :max-rating='5' :read-only='true' :starSize='20'/></td>
      </tr>
      <tr v-if="reports.length === 0">
        <td colspan="9" class="no-content">Ainda não tem resultado.</td>
      </tr>
    </tbody>
    <!-- <import-modals/> -->
  </table>
</template>

<script>
import InputStar from '_shared/InputStar.vue';

export default {
  name: 'report-quotation-table',
  components: {
    InputStar,
  },
  props: {
    reports: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

</style>
